import { useTranslation } from 'react-i18next'

import { CheckIcon } from '#/shared/ui/icons'

import type {
  CarrierRequestItem,
  CarrierRequestPending,
  CarrierRequestsHandlers,
} from '../model/types'
import { RequestRow } from './request-row'

interface RequestSectionProps {
  titleKey: string
  count: number
  requests: CarrierRequestItem[]
  distanceMiles?: number
  handlers: CarrierRequestsHandlers
  pending?: CarrierRequestPending | null
  totalDispatchedByYou?: number
}

export function RequestSection({
  titleKey,
  count,
  requests,
  distanceMiles,
  handlers,
  pending,
  totalDispatchedByYou,
}: RequestSectionProps) {
  const { t } = useTranslation()
  return (
    <section className="flex flex-col">
      <header className="flex h-10 items-center bg-warm-25 px-5 text-sm font-medium text-gray-900">
        {t(titleKey, { count })}
      </header>
      <div className="flex flex-col">
        {requests.map((request) => (
          <RequestRow
            key={request.id}
            request={request}
            distanceMiles={distanceMiles}
            handlers={handlers}
            pending={pending}
          />
        ))}
      </div>
      {totalDispatchedByYou !== undefined && totalDispatchedByYou > 0 && (
        <DispatchedFootnote count={totalDispatchedByYou} />
      )}
    </section>
  )
}

function DispatchedFootnote({ count }: { count: number }) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-1.25 px-5 py-2.5 text-xs text-gray-500">
      <CheckIcon className="size-3 text-gray-500" />
      {t('carrierRequests.totalDispatchedByYou', { count })}
    </div>
  )
}
